import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import { inputTilesActions, modalActions, accountActions, eventActions } from '../../redux/root-action';
import RetirementIncomeGoal from './RetirementIncomeGoal';
import YourContribution from './YourContribution';
import RetirementAge from './RetirementAge';
import SocialSecurity from './SocialSecurity';
import { modals, accountModalViews, eventModalViews } from '../../utils/constants';

const StyledLink = styled.a`
  text-decoration: none;
  &:hover,
  &:focus {
    text-decoration: none;
  }
`;

const StyledContainer = styled.div`
  border-radius: 4px;
  box-shadow: 0px 4px 4px rgba(45, 57, 64, 0.08), 0px 0px 2px rgba(45, 57, 64, 0.12);
  background-color: ${tokens.ColorWhite000};
  padding: 16px 24px;
  margin-bottom: 8px;
  cursor: pointer;
  :hover,
  :focus {
    box-shadow: 0px 8px 8px rgba(45, 57, 64, 0.06), 0px 0px 4px rgba(45, 57, 64, 0.06);
  }
  :active {
    box-shadow: 0px 8px 8px rgba(45, 57, 64, 0.06), 0px 0px 4px rgba(45, 57, 64, 0.06);
    border: solid 1px ${tokens.ColorBrandInteractiveBlue};
  }
  @media (max-width: 768px) {
    :active,
    :hover,
    :focus {
      box-shadow: 0px 8px 8px rgba(45, 57, 64, 0.06), 0px 0px 4px rgba(45, 57, 64, 0.06);
      border: solid 1px ${tokens.ColorBrandInteractiveBlue};
    }
  }
`;

const StyledTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const StyledTitle = styled.div`
  font-family: Nimbus Sans Bold;
  font-size: 16px;
  line-height: 22px;
  color: ${tokens.ColorGrey800};
`;

const StyledValue = styled.div`
  font-family: Nimbus Sans Bold;
  font-size: 16px;
  line-height: 22px;
  color: ${tokens.ColorBrandInteractiveBlue};
`;

const StyledSubTitle = styled.div`
  color: ${tokens.ColorGrey700};
  font-size: 16px;
  line-height: 22px;
`;

const StyledSubTitleValue = styled.div`
  color: ${tokens.ColorBrandInteractiveBlue};
  font-size: 16px;
  line-height: 22px;
`;

const components: any = {
  RetirementIncomeGoal: RetirementIncomeGoal,
  YourContribution: YourContribution,
  RetirementAge: RetirementAge,
  SocialSecurity: SocialSecurity,
};

class InputTile extends Component<any> {
  props: any;
  state: any;
  
  handleKeyPress = (e: any) => {
    if (e.nativeEvent.code === 'Enter') {
      this.handleInputTileClick();
    }
  };

  handleInputTileClick = () => {
    const { tile, showInputTilePopover, showModal, setCurrentViewAccounts, setCurrentViewEvents } = this.props;
    const mq = window.matchMedia('(max-width: 767px)');
    if (mq.matches) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      document.getElementsByTagName('html')[0].style.position = 'fixed';
    }
    if (tile === 'strategyBalance') {
      showModal(modals.ACCOUNT);
      setCurrentViewAccounts(accountModalViews.STRATEGY_MODAL);
    }
    if (tile === 'FutureIncomeExpenses') {
      showModal(eventModalViews.FUTURE_INCOME_MODAL);
    } else {
      showInputTilePopover(tile);
    }
  };

  render(): JSX.Element {
    const { tile, title, value, subTitle, spouseValue, selectedInputTile, subTitleValue, analyticsId, id, riScenario, tempScenarioEvents} = this.props;
    const TilePopoverComponent = components[tile];
    
    return (
      <React.Fragment>
        {selectedInputTile === tile && TilePopoverComponent && <TilePopoverComponent riScenario={riScenario} tempScenarioEvents={tempScenarioEvents}/>}
        <StyledLink onClick={this.handleInputTileClick} tabIndex={0} onKeyPress={this.handleKeyPress} id={analyticsId}>
          <StyledContainer id={id + `-input-tile-containter`}>
            <StyledTitleContainer id={id + `-input-title-container`}>
              <StyledTitle id={id + `-input-tile-title`}>{title}</StyledTitle>
              <StyledValue id={id + `-input-tile-value`}>{value}</StyledValue>
            </StyledTitleContainer>
            <StyledTitleContainer>
              <StyledSubTitle id={id + `-input-tile-sub-title`}>{subTitle}</StyledSubTitle>
              {spouseValue && <StyledValue id={id + `-input-tile-spouse`}>{spouseValue}</StyledValue>}
              {subTitleValue && (
                <StyledSubTitleValue id={id + `-sub-title-spouse-value`}> {subTitleValue}</StyledSubTitleValue>
              )}
            </StyledTitleContainer>
          </StyledContainer>
        </StyledLink>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    selectedInputTile: state.inputTile.selectedInputTile
  };
};

export default connect(mapStateToProps, {
  showInputTilePopover: inputTilesActions.showInputTilePopover,
  hideInputTilePopover: inputTilesActions.hideInputTilePopover,
  showModal: modalActions.showModal,
  setCurrentViewAccounts: accountActions.setCurrentView,
  setCurrentViewEvents: eventActions.setCurrentView,
})(InputTile);
